import { useEffect, useState } from 'react';
import { StoreState } from '@root/types';
import { getTourbookById } from '@store/selectors';
import { connect, ConnectedProps } from 'react-redux';
import tourbooksActions from '@store/actions/tourbooks';
import actions from '@store/actions/tourbookPage';
import Layout from './Layout';
import NotFound from '../404/NotFound';

const mapState = (state: StoreState, ownProps) => ({
  tourbook: getTourbookById(state, ownProps.match.params.tourbookId),
  tourbookId: ownProps.match.params.tourbookId,
});

const mapDispatch = {
  fetchTourbook: (id: string) => tourbooksActions.fetchTourbook(id),
  tourbookPageLoad: (id: string) => actions.tourbookPageLoad(id, true),
};

const connector = connect(mapState, mapDispatch);
type ReduxProps = ConnectedProps<typeof connector>;

export const Tourbook = ({ tourbook, fetchTourbook, tourbookId, tourbookPageLoad }: ReduxProps) => {
  const [loading, setLoading] = useState(true);
  const fetchCurrentTourbook = () => fetchTourbook(tourbookId);

  useEffect(() => {
    tourbookPageLoad(tourbookId).then(() => {
      setLoading(false);
    });
  }, []);

  if (loading) return null;

  return tourbook ? (
    <Layout tourbook={tourbook} fetchTourbook={fetchCurrentTourbook} readOnly />
  ) : (
    <NotFound isTransientPage />
  );
};

export default connector(Tourbook);
